import React, {Component} from 'react';
import {connect} from 'react-redux';
import memoize from 'memoize-one';

import {Toolbar} from 'primereact/toolbar';

import metaModel from '~/shared/src/utilities/metaModel';

import {getStatusDisplayName} from '~/frontend/src/utilities/renderHelpers';
import {statusColoringRenderer} from '~/frontend/src/utilities/valueRenderers';
import {__} from '~/shared/src/utilities/messageCatalog';
import {StoreState} from '~/frontend/src/store';
import User from '~/shared/src/model/User';

const defaultProps = {
    /**
     * Is the Sidebar visible <strong>or</strong> not.
     */
    visible: false as boolean
};

type DefaultProps = typeof defaultProps;

type Props = {

    /**
     * The uniqueId of the panel the component is used in.
     *
     * Mostly used to extract the components state from the global one
     * and to generate unique dom element ids.
     */
    uid : string;

    /**
     * The database schema to filter data and metadata for.
     */
    schema : Schema;

    /**
     * Should the MetaModel information shown as defined (raw) <strong>or</strong> should they be processed by MessageCatalog.
     */
    rawMode : boolean;

    /**
     * Should the MetaModel information as defined additionally shown for processed information <strong>or</strong> not.
     * This applies in the form: &lt;processed MetaModel information&gt; (&lt;defined MetaModel information&gt;)
     *
     * Only applicable if <prop>rawMode</prop> is set to false.
     */
    showAdditionalRawNames : boolean;
};

type StateProps = {

    /**
     * The current user.
     *
     * Will be mapped from global state.
     */
    user? : User;
};

//type ComponentPros = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props & StateProps;


/**
 * ItemFinderLegendbar
 */
class ItemFinderLegendbar extends Component<AllProps> {

    static defaultProps = defaultProps;

    /**
     * @param props
     */
    constructor( props : AllProps ) {
        super( props );

        this.getData = memoize( this.getData );
    }

    getData( uid : string, schema : Schema, rawMode : boolean, showAdditionalRawNames : boolean, language? : string ) {
        const retVal   = [],
              statuses = metaModel[ schema ].getStatuses();

        let i;

        // sort
        statuses.sort( ( val1, val2 ) => {
            if ( val1.description > val2.description ) {
                return 1;
            }
            else if ( val1.description < val2.description ) {
                return -1;
            }
            else {
                return 0;
            }
        } );

        // build components
        for ( i = 0; i < statuses.length; i++ ) {
            if ( retVal.length ) {
                retVal.push( <i key={`${uid}_separator_${i}`} className="p-toolbar-separator"/> );
            }
            retVal.push( statusColoringRenderer( <>{getStatusDisplayName( statuses[ i ].id, schema, rawMode, showAdditionalRawNames )}</>, statuses[ i ].id, schema, `${uid}_status_${i}` ) )
        }

        // property defaults components
        retVal.push( <i key={`${uid}_separator_${i}`} className="p-toolbar-separator"/> );
        retVal.push( statusColoringRenderer( <>{__( 'YN.base.finder.propertyDefaults.label' )}</>, 0, undefined, `${uid}_pDefault`, undefined, 'property-default' ) );

        return retVal;
    }

    /**
     * REACT lifecycle method
     */
    render() {
        const {
                  uid,
                  schema,
                  rawMode,
                  showAdditionalRawNames,
                  visible,
                  user
              }         = this.props,
              data      = this.getData( uid, schema, rawMode, showAdditionalRawNames, user?.language ),
              className = [ 'yn-panel-toolbar', 'yn-panel-toolbar-border-top', 'yn-toolbar-collapsable', 'yn-legendbar' ];

        if ( !visible ) {
            className.push( 'yn-collapsed' );
        }

        return <Toolbar
            left={[]}
            right={data}
            className={className.join( ' ' )}
        />;
        /*return <Sidebar
            visible={this.props.visible}

            showCloseIcon={false}
            dismissable={false}
            modal={false}
            onHide={() => {
            }}
            position="bottom"
            className="yn-legendbar"
            style={{ zIndex: 2 }}
        >
            <Toolbar
                left={[]}
                right={data}
                className="yn-panel-toolbar"
            />
        </Sidebar>;*/
    }
}

/**
 * REDUX stuff
 */
function mapStateToProps( state : StoreState ) : StateProps {
    const retVal : StateProps = {
        user: undefined
    };

    // get some session user information
    if ( state.session?.user ) {
        retVal.user = state.session.user;
    }

    return retVal;
}

export default connect( mapStateToProps, null )( ItemFinderLegendbar );
